import { render, staticRenderFns } from "./RewardClients.vue?vue&type=template&id=47481202&"
import script from "./RewardClients.vue?vue&type=script&lang=js&"
export * from "./RewardClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports